import debug from 'debug'

/**
 * @function
 * @param {Object} deps
 * @param {String} deps.prefix
 * */
const factoryLogger = ({prefix} = {}) => debug(`mt:${prefix}`)

export default factoryLogger
